export {
  type MappedLocation,
  type MappedCity,
  type MappedAirport,
  type MappedCountry,
  LocationType,
} from './avia-search-form';
export {
  type RWDict,
  type RWMappedCity,
  type MappedStation,
  type RWMappedLocation,
} from './railways-search-form';
